/*
*   @site           Preloaded: Site
*   @function       Module: Specialism Carousel
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Imports
//-----------------------------------------------

//Parent
import ModuleCarousel from '../_templates/ModuleCarousel';

//Libs
import { gsap } from 'gsap';


//-----------------------------------------------
// Class Definition
//-----------------------------------------------
export default class ModuleCarouselSpecialism extends ModuleCarousel {


  //-----------------------------------------------
  // Init
  //-----------------------------------------------
  init() {
    //Current theme
    this.theme = '';

    //Find the flourish
    this.flourish = this.element.querySelector('.flourish');

    //Main
    super.init();
  }

  
  //-----------------------------------------------
  // Slide Content Init
  //-----------------------------------------------
  slideContentInit(id, element, type) {
    //Data
    let data = {
      theme: element.getAttribute('data-theme'),
      imageElement: element.querySelector('.image'),
      image: element.querySelector('.image img')
    };

    //Snap animation to out
    gsap.to(data.imageElement,{ opacity: 0, duration: 0, delay: 0, ease:'quad.inOut'});

    //Default
    return data;
  }


  //-----------------------------------------------
  // Item Acrtive
  //-----------------------------------------------
  itemActive(id, active, isFirstRun) {
    //Parent
    super.itemActive(id, active, isFirstRun);

    //Stop tweens
    gsap.killTweensOf(this.slides[id].content.imageElement);
    gsap.killTweensOf(this.slides[id].content.image);

    //Theme
    if(active) {
      //Theme
      if(this.theme !== '') {
        this.element.classList.remove('theme-' + this.theme);
        (this.flourish) ? this.flourish.classList.remove('fill-' + this.theme) : null;
      }

      //Set new theme
      let theme = this.slides[id].content.theme;
      this.element.classList.add('theme-' + theme);
      (this.flourish) ? this.flourish.classList.add('fill-' + theme) : null;
      this.theme = theme;

      //Animate the image if not the first run, else just set it in place
      if(isFirstRun) {
        //Snap in
        gsap.to(this.slides[id].content.imageElement, { opacity: 1, duration: 0});
      } else {
        //In
        gsap.to(this.slides[id].content.imageElement, {opacity: 1, duration: 0.5, delay: 0.35, ease:'quad.inOut'});
        gsap.fromTo(this.slides[id].content.image, {scale:1.06}, {scale: 1, duration: 0.5, delay: 0.35, ease:'quad.inOut'});
        
      }
    } else {
      //Off
      gsap.to(this.slides[id].content.imageElement, { opacity: 0, duration: 0.3, delay: 0, ease:'quad.in'});
    }
  }

}